import { Link } from "react-router-dom";
import type { Movie } from "@/types";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex animate-fade-in-up cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300/70 bg-background-50 transition-colors hover:border-primary-300"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 香港三级片电影`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-background-50/95 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
          <i className="ri-star-fill text-accent-500" />
          {movie.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {movie.year} · {movie.director} 导演
        </p>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{movie.synopsis}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {movie.genre.slice(0, 3).map((genre) => (
            <span key={genre} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}